import { render, staticRenderFns } from "./month.vue?vue&type=template&id=4a0584bc&scoped=true"
import script from "./month.vue?vue&type=script&lang=js"
export * from "./month.vue?vue&type=script&lang=js"
import style0 from "./month.vue?vue&type=style&index=0&id=4a0584bc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0584bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0584bc')) {
      api.createRecord('4a0584bc', component.options)
    } else {
      api.reload('4a0584bc', component.options)
    }
    module.hot.accept("./month.vue?vue&type=template&id=4a0584bc&scoped=true", function () {
      api.rerender('4a0584bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schedule/month.vue"
export default component.exports